import api from '../helpers';

export default {
  passwordResetRequest: {
    key: 'postPasswordResetRequest',
    query: (email) => {
      return api.post('/api/reset-user-password', {
        headers: {
          'Content-Type': 'application/json',
        },
        _throwError: false,
        data: {
          email,
          useCodeUrl: `${window.location.origin}/reset-password?mode=resetPassword`,
        },
      });
    },
  },
  passwordResetCode: {
    key: 'postPasswordResetCode',
    query: (code, password) => {
      return api.post(`/api/reset-user-password/${code}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        _throwError: false,
        data: {
          password,
        },
      });
    },
  },
  list: {
    key: 'fetchUsers',
    query: () => {
      return api.get('/api/users', {
        headers: {
          'Content-Type': 'application/json',
        },
        params: { offset: 0, limit: -1 },
      });
    },
    mapper: ({ data }) => data,
  },
  create: {
    key: 'createUser',
    query: (firstName, lastName, email, companyId, role, password) => {
      return api.post('/api/users', {
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          firstName,
          lastName,
          email,
          companyId,
          role,
          password,
        },
      });
    },
  },
  change: {
    key: 'changeUser',
    query: (userId, properties) => {
      const data = ['firstName', 'lastName', 'companyId', 'role', 'isActive'].reduce((acc, field) => {
        if (Object.prototype.hasOwnProperty.call(properties, field) && typeof properties[field] !== 'undefined') {
          return { ...acc, [field]: properties[field] };
        }
        return acc;
      }, {});

      return api.put(`/api/users/${userId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
  delete: {
    key: 'deleteUser',
    query: (userId) => {
      return api.delete(`/api/users/${userId}`, {});
    },
  },
  editUserPassword: {
    key: 'editUserPassword',
    query: (id, password) => {
      return api.put(`/api/users/${id}/password`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data: { password },
      });
    },
  },
  editSubRenewalDate: {
    key: 'editSubRenewalDate',
    query: (id, subRenewalDate) => {
      return api.put(`/api/users/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data: { subRenewalDate },
      });
    },
  },
  addProfilePhoto: {
    key: 'addProfilePhoto',
    query: (photo) => {
      return api.post('/api/my/photo', {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: {
          photo,
        },
      });
    },
  },
  updatePassword: {
    key: 'updatePassword',
    query: (currentPassword, newPassword) => {
      return api.post('/api/my/password', {
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          currentPassword,
          newPassword,
        },
      });
    },
  },
  getAccountQuota: {
    key: 'fetchAccountQuota',
    query: (accountId) => {
      return api.get(`/api/users/${accountId}/quota`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
  },
  setAccountQuota: {
    key: 'setAccountQuota',
    query: (accountId, quota, used, threshold) => {
      return api.put(`/api/users/${accountId}/quota`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          quota,
          used,
          threshold,
        },
      });
    },
  },
  inviteUsers: {
    key: 'inviteUsers',
    query: ({ emails, companyId }) => {
      return api.post('/api/users/invite', {
        headers: {
          'Content-Type': 'application/json',
        },
        data: { emails, companyId },
      });
    },
  },
};
